let clientApiKey = null;

/**
 * Remember the API key boot resolved for this client.
 *
 * `initializeClientServices` picks one key per platform — desktop, mobile web, each native WebView —
 * and every request the funnel makes carries that one. Anything outside the API clients that has to
 * identify itself with the tenant's key reads it from here instead of picking again from
 * `env.api`, so the whole page speaks as a single client.
 * @param {string} key - The resolved key.
 * @returns {void}
 */
export function holdClientApiKey(key) {
  clientApiKey = key || null;
}

/**
 * The API key boot resolved for this client, or null before boot has run.
 * @returns {string|null} The key.
 */
export function readClientApiKey() {
  return clientApiKey;
}
